
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import PasswordMixin from '@/mixins/PasswordMixin';
import LoadingMixin from '@/mixins/LoadingMixin';

@Component
export default class Login extends mixins(LoadingMixin, PasswordMixin) {
  username = '';
  password = '';
  location = '';
  email = '';
  remember = false;
  revealPassword = false;
  showForgot = false;
  isLoading = false;
  currentSource = '';

  mounted() {
    // Ambil nilai 'source' dari query parameter URL
    this.currentSource =
      new URL(window.location.href).searchParams.get('source') || '';
  }
  get appName() {
    return process.env.VUE_APP_NAME;
  }
  get rules() {
    return {
      username: 'required',
      password: 'required',
    };
  }
  get emailRules() {
    return [
      (v: string | null) => !!v || 'Email tidak boleh kosong',
      (v: string) => /.+@.+\..+/.test(v) || 'Format email tidak valid',
    ];
  }

  get isEmailValid() {
    // Apply the email rules
    return this.emailRules.every(rule => rule(this.email) === true);
  }

  async onSubmit() {
    this.isLoading = true;
    this.$alert.hide();
    this.$snackbar.hide();
    // Ambil 'source' dari query parameter dan simpan di 'this.location'
    this.location =
      new URL(window.location.href).searchParams.get('source') || '';
    this.startLoading();
    const res = await this.$store.dispatch('auth/login', {
      username: this.username,
      password: this.password,
      location: this.location,
    });
    this.finishLoading();
    if (res.status === 200) {
      if (this.differentDatePassword >= 90) {
        this.isLoading = false;
        this.$router.push('/change-password');
      } else {
        this.isLoading = false;
        const next: string = (this.$route.query.next || '/').toString();
        this.$router.push(next);
      }
    } else {
      this.isLoading = false;
      this.$alert.error(res.errors[0]?.message || res?.message);
    }
  }
  async onResetPassword() {
    this.isLoading = true;
    this.$alert.hide();
    this.$snackbar.hide();
    this.startLoading();

    try {
      const res = await this.$store.dispatch('auth/getLinkresetPassword', {
        email: this.email,
      });

      if (res.status === 200) {
        this.$alert.success(res.data.message);
        this.showForgot = false;
      } else if (res.status === 404 || res.status === 406) {
        this.$alert.error(res.data.message);
        this.showForgot = false;
      } else {
        this.$alert.error(
          res.errors?.[0]?.message || res?.message || 'Terjadi kesalahan',
        );
        this.showForgot = false;
      }
    } catch (error) {
      // Handle network or unexpected errors
      this.showForgot = false;
      this.$alert.error('Terjadi kesalahan jaringan');
    } finally {
      this.finishLoading();
      this.isLoading = false;
      this.showForgot = false;
    }
  }
}
